import { apiClient } from "@api/apiClient";

const API_ENDPOINT = "/des/region-country/dropdown";

export const getTerritoryControlledList = async () => {
  const response = await apiClient.get(API_ENDPOINT);
  return response.data;
};
